import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/template/get-templates';

  return API({ endpoint });
}
